import { useDataIsSubmitting, useDataValue } from 'Simple/Data.js'
import { textInput, numberPositive } from 'Data/validate.js'

export function useIsDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'question',
    viewPath: props.viewPath,
  })

  let value = useDataValue({
    context: 'question',
    viewPath: props.viewPath,
  })

  return (
    isSubmitting ||
    !textInput(value.prompt) ||
    !numberPositive(value.order) ||
    (['choice', 'multichoice', 'list'].includes(value.type) &&
      !textInput(value.options))
  )
}
